var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.43 101.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#164194;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#6db22d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-EIT-Urban-Mobility") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.86,
    y: 33.91,
    width: 2.88,
    height: 2.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.86,
    y: 39.6,
    width: 2.88,
    height: 22.68
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.36,281.74h2.88v5.68h11.31v2.88H294.24v14.12a2.79,2.79,0,0,0,2.81,2.88h8.5v2.8h-8.5a5.7,5.7,0,0,1-5.69-5.68V290.3h-4.25v-2.88h4.25Z",
    transform: "translate(-229.01 -247.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.88,298.8h22.18a27.33,27.33,0,0,0-.43-5.62,8.49,8.49,0,0,0-1.52-3.24,7.08,7.08,0,0,0-3.6-2.23,33.12,33.12,0,0,0-7.2-.57,34,34,0,0,0-7.27.57,6.68,6.68,0,0,0-3.53,2.23,6.83,6.83,0,0,0-1.51,3.24,31,31,0,0,0-.5,5.62,30.52,30.52,0,0,0,.5,5.54,6.74,6.74,0,0,0,1.51,3.24,6.3,6.3,0,0,0,3.53,2.24,29.86,29.86,0,0,0,7.27.57,29.15,29.15,0,0,0,7.2-.57,6.66,6.66,0,0,0,3.6-2.24,8,8,0,0,0,1.3-2.44H276a10.59,10.59,0,0,1-.72.86,6.42,6.42,0,0,1-2.74,1.15,31.87,31.87,0,0,1-5.18.29,30.86,30.86,0,0,1-5.19-.29,6,6,0,0,1-2.73-1.15,5.08,5.08,0,0,1-1.52-3.6c-.07-1.15-.07-2.45-.07-3.6Zm18.94-2.88H257.88c.07-2.09.58-3.53,1.59-4.32a5.22,5.22,0,0,1,2.73-1.15,29.34,29.34,0,0,1,5.19-.36,30.46,30.46,0,0,1,5.18.36,5.57,5.57,0,0,1,2.74,1.15C276.31,292.39,276.82,293.83,276.82,295.92Z",
    transform: "translate(-229.01 -247.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.06,349.78a51,51,0,1,0-25.49-95.12l2.81,4.9a44.83,44.83,0,0,1,22.68-6.05A45.33,45.33,0,1,1,234.7,298.8H229A51,51,0,0,0,280.06,349.78Z",
    transform: "translate(-229.01 -247.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.06,338.47A39.57,39.57,0,0,0,314.4,318.6l-4.89-2.81a34,34,0,1,1,0-34.05l4.89-2.81a39.67,39.67,0,1,0-34.34,59.54Z",
    transform: "translate(-229.01 -247.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.3,287.38v14.15c0,4.32.27,5,2.17,5.48a42.75,42.75,0,0,0,7.52.4c7.28,0,9.49-.27,10.31-1.22.64-.75.68-1.12.71-7.65V287.38h3v11.16a61.67,61.67,0,0,1-.17,6.26c-.24,2.75-1.63,4.38-4.12,4.86a69.43,69.43,0,0,1-9.08.48,57.94,57.94,0,0,1-9.32-.48,4.89,4.89,0,0,1-3.84-4.46,47.47,47.47,0,0,1-.24-6.66V287.38Z",
    transform: "translate(-229.01 -247.82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.58,294.32v2.11h.17a3.94,3.94,0,0,1,1.87-1.7c.95-.48,2.28-.62,5.27-.62s4.36.28,5.41,1.19a5.64,5.64,0,0,1,1.6,4.46v1.63h-2.55v-1.12c0-3.26-.85-4-4.73-4-6,0-7,.95-7,6.5v7.28H375.1V294.32Z",
    transform: "translate(-229.01 -247.82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396,287.38v8.81h.17c1.12-1.7,2.52-2.11,7-2.11,5.34,0,6.94.27,8.37,1.36,1.7,1.33,2.38,3.27,2.38,7,0,4-1.06,6.16-3.57,7.18-1.3.51-2.9.68-6.77.68-5,0-6.3-.37-7.49-2.21H396v2H393.5V287.38Zm-.07,14.83c0,3.23.51,4.52,2.08,5.24.95.47,2.82.64,6.46.64,5.58,0,6.8-1,6.8-5.85,0-3.16-.61-4.66-2.14-5.37-.95-.44-2.62-.61-5.92-.61C397,296.26,395.91,297.14,395.91,302.21Z",
    transform: "translate(-229.01 -247.82)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.42,299.05v-.68c0-3.3,2-4.26,8.85-4.26,5.34,0,7.17.38,8.5,1.77,1.09,1.09,1.33,2.15,1.33,5.89v8.3h-2.49l0-1.84h-.1c-1.19,1.7-2.35,2-7.15,2-5.64,0-7.14-.2-8.3-1.09s-1.36-1.77-1.36-3.67c0-2.48.61-3.71,2.25-4.32.95-.37,2.45-.51,5.78-.51,6.46,0,7.55.2,8.64,1.7h.2v-1.7c0-1.63-.17-2.31-.74-3-.89-1.09-2.32-1.4-6.43-1.4-5.41,0-6.36.38-6.4,2.55v.21Zm2.89,4.38a2.33,2.33,0,0,0-.91,2.11,2,2,0,0,0,1.22,2.15c.71.3,2.42.4,6.29.4,5.28,0,6.53-.51,6.53-2.61s-1.49-2.59-7-2.59C421.22,302.89,420,303,419.31,303.43Z",
    transform: "translate(-229.01 -247.82)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.2,294.32v2.38h.2c1-2,2.76-2.59,7.93-2.59,4.52,0,6.39.41,7.62,1.74.95,1,1.29,2.38,1.29,5.34v8.88h-2.48v-7.83c0-2.82-.17-3.77-.89-4.59-.81-1-2.38-1.36-5.81-1.36-3.88,0-5.86.51-6.94,1.84-.79.92-.92,1.66-.92,4.66v7.28h-2.49V294.32Z",
    transform: "translate(-229.01 -247.82)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.75,287.38l12.32,19.25,12.07-19.25h6.09v22.69h-3V290.2H501l-12.66,19.87h-2.45L473.05,290.2h-1.32v19.87h-3V287.38Z",
    transform: "translate(-229.01 -247.82)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526,295.24c1.91,1.22,2.69,3.26,2.69,6.94s-.85,5.95-2.82,7.07c-1.36.78-3.13,1-7.15,1-4.62,0-6.56-.27-8-1.12-2-1.16-2.79-3.16-2.79-7s.95-6,3-7.08c1.29-.68,3.06-.92,6.63-.92C522.71,294.11,524.65,294.39,526,295.24Zm-15.41,7c0,3.26.65,4.66,2.49,5.3,1,.38,2.51.51,5.44.51,3.67,0,5.07-.23,6.09-1s1.43-2.21,1.43-5c0-3.1-.58-4.49-2.18-5.21-1-.44-2.65-.61-5.85-.61C511.73,296.29,510.6,297.21,510.6,302.28Z",
    transform: "translate(-229.01 -247.82)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.66,287.38v8.81h.17c1.13-1.7,2.52-2.11,7-2.11,5.34,0,6.94.27,8.37,1.36,1.7,1.33,2.38,3.27,2.38,7,0,4-1.05,6.16-3.57,7.18-1.29.51-2.89.68-6.77.68-5,0-6.29-.37-7.48-2.21h-.14v2h-2.45V287.38Zm-.06,14.83c0,3.23.51,4.52,2.07,5.24,1,.47,2.82.64,6.46.64,5.58,0,6.81-1,6.81-5.85,0-3.16-.61-4.66-2.15-5.37-.95-.44-2.61-.61-5.91-.61C534.69,296.26,533.6,297.14,533.6,302.21Z",
    transform: "translate(-229.01 -247.82)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.56,287.38v3h-2.49v-3Zm0,6.94v15.75h-2.49V294.32Z",
    transform: "translate(-229.01 -247.82)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562,287.38v22.69h-2.49V287.38Z",
    transform: "translate(-229.01 -247.82)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.44,287.38v3H565v-3Zm0,6.94v15.75H565V294.32Z",
    transform: "translate(-229.01 -247.82)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.19,290.41v3.91h11v2.14h-11v6.8c.07,3,.07,3.1.58,3.75s1.77,1.08,4.15,1.08c2.21,0,3.06-.23,3.61-1.08.37-.58.47-1.16.47-3.1v-1h2.49v1c0,2.45-.21,3.47-.85,4.42-.92,1.4-2.62,1.94-6,1.94s-5.17-.51-6.09-1.77c-.68-.95-.88-1.94-.88-4.42v-7.62h-3.88v-2.14h3.88v-3.91Z",
    transform: "translate(-229.01 -247.82)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.51,294.32l7.62,13.74h.31l7.07-13.74h2.93L599.75,309c-1.8,3.47-2.62,4.6-3.88,5.48s-2.38,1.09-5,1.09c-.55,0-.85,0-1.4,0v-2.27a7.71,7.71,0,0,0,1.16.06c3.3,0,4.15-.51,5.65-3.26h-.85l-8.88-15.75Z",
    transform: "translate(-229.01 -247.82)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEit);
export default __webpack_public_path__ + "static/media/logo-EIT.4613493813282788230f463ca74adfc5.svg";
export { ForwardRef as ReactComponent };